/**
 * Does this account have admin rights?
 *
 * THE MIRROR OF `server/utils/permissions.js`, and it exists for the reason
 * that file states: `isAdmin` is a legacy boolean that predates the `role`
 * enum, the two can disagree, and every place that checks only one of them
 * eventually disagrees with every place that checks the other.
 *
 * The server already resolves the pair — `isAdminAccount` for HTTP, and the
 * handshake in socket.js for the game. The client had three separate opinions:
 * `AdminRoute` and `Header` tested `isAdmin` alone while `Play` tested both. An
 * account promoted with `npm run set-role -- someone --role admin` (which
 * deliberately leaves `isAdmin` untouched) was therefore admitted by the API,
 * given unpublished characters in the game, and then bounced off /admin by the
 * router — visible as "the admin pages are broken for me".
 *
 * This is the one client-side answer. The server still decides what is
 * permitted; this only decides what is offered.
 */
export function isAdminAccount(user) {
  return Boolean(user?.isAdmin) || user?.role === 'admin';
}

export default isAdminAccount;
